

import { mapState, mapStores } from 'pinia';
import { defineComponent, PropType } from 'vue';
import { v4 as uuidv4 } from 'uuid';

import { useWidgetStore } from '~/store/widgets.store';
import { WidgetMode } from '~/components/widgets/widget.vue';
import { GridStack, GridStackElement } from 'gridstack';
import { Widget, WidgetType } from '~/models/widget.model';
import registry from '~/components/widgets/widget-registry';

export default defineComponent({

    components: {
        ...registry.getComponents(),
    },

    data() {
        return {
            grid: null as GridStack,
            WidgetMode,
            selected: new Set<WidgetType>(),
        }
    },

    props: {
        widgets: { type: Array as PropType<Widget[]>, default: () => []},
    },

    computed: {
        ...mapStores(useWidgetStore),
        ...mapState(useWidgetStore, ['templates']),

        cellHeight() {
            //@ts-ignore
            return Math.max(this.$refs?.grid?.offsetHeight / 3, 230);
        },
    },

    async mounted() {
        this.selected = new Set(this.widgets?.map((widget: Widget) => widget.type));
        this.resetGrid();
    },

    methods: {
        async resetGrid(): Promise<void> {
            if(!this.$refs.grid) {
                return;
            }

            if (this.grid) {
                this.grid.off('change');
                this.grid.destroy(false);
                this.grid = null;
            }
            this.grid = GridStack.init({
                disableResize: true,
                disableDrag: true,
                cellHeight: this.cellHeight,
                column: 12,
                minRow: 3,
            }, this.$refs.grid as GridStackElement);
        },

        onWidgetClick(widget: Widget, event: Event) {
            event.stopPropagation();

            if(this.selected.has(widget.type)) {
                this.selected.delete(widget.type);
            } else {
                this.selected.add(widget.type);
            }

            const widgets = Array.from(this.selected).map((type: WidgetType) => {
                const widget = this.widgets.find((widget: Widget) => widget.type === type);
                if(widget) {
                    return {...widget};
                }

                const template = this.templates.find((widget: Widget) => widget.type === type);
                if(template) {
                    return {...template, id: uuidv4()};
                }

                return null;
            }).filter(w => !!w);

            this.$emit('add-widget-grid:change', widgets);
        },
    }
});

